/** Lowercase and strip accents so "Pacífico" matches "pacifico" */
export function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
}

export function onlyDigits(value: string): string {
  return value.replace(/\D/g, '')
}

export function formatNumber(value: number): string {
  return value.toLocaleString('es-CO')
}
